import React from 'react';
import Layout from './Layout';
import useNavigationItems  from '@config/navigationmenu';

const FlexEZPageLayout = ({ children, headerProps }) => {
    const items = useNavigationItems();

	const newHeaderProps = { ...headerProps,
			navigationItems: items,
			initActiveSection: "flexez" };

	return (
	<Layout headerProps={ newHeaderProps }>
		{ children }
	</Layout>
	);
};

export default FlexEZPageLayout;
